import { FormValidator } from '../../utils';

export class PasswordAuthValidator extends FormValidator {
  newPassword(validator) {
    validator.isValidPassword();
  }
}
